/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable no-extra-boolean-cast */
import { CloseOutlined } from '@ant-design/icons'
import { Button, Form, notification, Space, Spin } from 'antd'
import dayjs from 'dayjs'
import React, { PropsWithChildren, useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useQueryClient } from 'react-query'

import { QUERY_KEYS } from '@api'
import { useGeneral, useHandleDeleteTicketModal, useHandleTicketModal } from '@contexts'
import { useConfigurationProperties, useTicketsById } from '@hooks'
import { CommonTicketForm, DeliveryNote, StatusTicketEnum, Ticket } from '@types'
import { CutoffTimeUtils, DeliveryNoteUtils } from '@utils'

import RedirectToTicket from '../../../components/RedirectToTicket'
import ShareTicket from '../../../components/ShareTicket'
import { FlexRow, StyledModal } from '../../../components/StyledComponents'
import UpdateTicketFormSupplier from './UpdateTicketFormSupplier'

const { TICKET, PURCHASES } = QUERY_KEYS
const { CREATED } = StatusTicketEnum

const primaryButtonInitialState = (ticket: Ticket): boolean =>
  !(ticket.status.name === CREATED && !!ticket.ticketAssignments?.length)

const today = dayjs()
const tomorrow = today.clone()
tomorrow.add(1, 'day').startOf('d')

type Props = {
  onOk: (
    id: number | undefined,
    form: CommonTicketForm,
    resetForm: () => void,
    dates: Date[] | undefined,
    toApprove?: boolean | undefined,
  ) => void
  title: string
  isLoading: boolean
  onClose: (reset?: () => void) => void
  open?: boolean
}

const UpdateTicketModalSupplier: React.FC<Props> = ({ onClose, title, onOk, isLoading, open }) => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { setFormInstance } = useGeneral()
  const { ticketById, isTicketByIdLoading } = useTicketsById()
  useHandleDeleteTicketModal()
  const { ticketToEdit, setTicketToEdit, setIsTicketModalOpen, isTicketModalOpen } =
    useHandleTicketModal()
  const { maxAllowedDaysForSupplierRequest, cutoffTimeHour } = useConfigurationProperties()
  const [form] = Form.useForm()
  const [editable, setEditable] = useState<boolean>()
  const [isWarning, setIsWarning] = useState<boolean>()
  const [ifToApproved, setIfToApproved] = useState<boolean>()
  const [dates, setDates] = useState<Date[]>()
  const [primaryButtonIsDisabled, setPrimaryButtonIsDisabled] = useState<boolean>()
  const cutoffTime =
    typeof cutoffTimeHour === 'number' && !Number.isNaN(cutoffTimeHour)
      ? `${String(cutoffTimeHour).padStart(2, '0')}:00`
      : CutoffTimeUtils.getCutoffTime()

  const handlePrimaryButtonDisabling = useCallback((value: boolean) => {
    setPrimaryButtonIsDisabled(!!value)
  }, [])

  const resetModal = useCallback(() => {
    setTicketToEdit(0)
    setIsTicketModalOpen(false)
    queryClient.removeQueries([TICKET, PURCHASES])
    notification.destroy('validationError')
    setEditable(undefined)
    setIsWarning(undefined)
    setIfToApproved(undefined)
    setDates(undefined)
    setPrimaryButtonIsDisabled(undefined)
  }, [ticketToEdit])

  const handleCloseModal = () => {
    onClose()
  }

  const handleAfterModalClose = () => {
    setDates(undefined)
  }

  const ticketModalHeader = useCallback(() => {
    const modalTitle = ticketToEdit
      ? `${t('globals.generics.request')}${
          ticketById?.ticket?.id ? ` #${ticketById?.ticket?.id}` : ''
        }${
          ticketById?.ticket?.status?.name
            ? ` - ${t(`globals.generics.status.${ticketById.ticket.status.name.toLowerCase()}`)}`
            : ''
        }`
      : title

    return modalTitle
  }, [ticketToEdit, ticketById])

  const DinamicTitle: React.FC<PropsWithChildren> = useCallback(
    ({ children }) => (
      <Space className="ticket-modal-header-tools">
        {children}
        {ticketById?.ticket?.id && (
          <FlexRow style={{ marginTop: '-6px' }}>
            <RedirectToTicket ticketId={ticketById.ticket.id} />
            <ShareTicket ticketId={ticketById.ticket.id} />
          </FlexRow>
        )}
      </Space>
    ),
    [ticketById],
  )

  const proceed = useCallback(() => {
    if (dates?.length === undefined) {
      setIsWarning(true)
    }
    form.setFieldsValue({ datesInput: dates?.length ? true : undefined })
    form
      .validateFields()
      .then(values => {
        const deliveryNoteNumber = DeliveryNoteUtils.normalizeValue(values.number)
        const deliveryNote: DeliveryNote | undefined = deliveryNoteNumber
          ? {
              number: deliveryNoteNumber,
              ...(values.observation ? { observation: values.observation } : {}),
            }
          : undefined

        onOk(
          ticketById?.ticket?.id,
          {
            ...(deliveryNote && { deliveryNote }),
            count: values.count,
            depotId: values.depotId,
            materialId: values.materialId,
            equipmentId: values.equipmentId,
            destinationId: values.destinationId,
            carrierId: values.carrierId,
            note: values.comments ? { description: values.comments } : undefined,
            documentNumberId: values.documentNumberId ?? undefined,
            declinedLoad: values.declinedLoad,
            declinedLoadType: values.declinedLoadType,
            tripType: values.tripType,
            ticketSap:
              typeof values.ticketSap === 'string' && /^\d+$/.test(values.ticketSap)
                ? values.ticketSap
                : null,
          },
          handleCloseModal,
          dates,
          !!ifToApproved,
        )
      })
      .catch(e => {
        console.log('e :>> ', e)
        notification.destroy('validationError')
        notification.error({
          message: t('globals.validation_error'),
          key: 'validationError',
        })
      })
  }, [dates, ticketToEdit, ticketById, ifToApproved])

  useEffect(() => {
    if (ticketById?.ticket) {
      setIfToApproved(false)
      handlePrimaryButtonDisabling(primaryButtonInitialState(ticketById.ticket))
      setIsTicketModalOpen(true)
    }
  }, [ticketById])

  useEffect(() => {
    if (!open) {
      resetModal()
    } else if (!ticketToEdit) {
      handlePrimaryButtonDisabling(false)
    }
  }, [open])

  useEffect(() => {
    if (form) {
      setFormInstance(form)
    }
    return () => {
      setFormInstance(undefined)
    }
  }, [form])
  return isTicketModalOpen && ticketById?.ticket ? (
    <StyledModal
      key={ticketToEdit}
      afterClose={handleAfterModalClose}
      destroyOnClose
      keyboard
      maskClosable
      className={`edit-modal ${!!(ticketById && !editable) && 'detail-modal'} supplier-modal`}
      open={open}
      onCancel={handleCloseModal}
      title={<DinamicTitle>{ticketModalHeader()}</DinamicTitle>}
      closeIcon={<CloseOutlined />}
      cancelText={t('suppliers_router.new_ticket_modal.cancelText')}
      footer={[
        <Button key="cancelar" onClick={handleCloseModal} target="closeModalButton">
          {t('suppliers_router.new_ticket_modal.cancelText')}
        </Button>,
        <Button type="primary" key="ok" onClick={proceed} disabled={primaryButtonIsDisabled}>
          {t('suppliers_router.new_ticket_modal.okText')}
        </Button>,
      ]}
    >
      <Spin
        className="ticket-modal-spinner"
        size="large"
        spinning={isLoading || isTicketByIdLoading}
      >
        <UpdateTicketFormSupplier
          ticket={ticketById.ticket}
          editable={editable}
          setEditable={setEditable}
          dates={dates}
          setDates={setDates}
          isWarning={isWarning}
          setIsWarning={setIsWarning}
          form={form}
          maxAllowedDaysForSupplierRequest={maxAllowedDaysForSupplierRequest}
          handlePrimaryButtonDisabling={handlePrimaryButtonDisabling}
          cutoffTime={cutoffTime}
        />
      </Spin>
    </StyledModal>
  ) : null
}
export { UpdateTicketModalSupplier }
